
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clear-frontier/preview/s/[static]",
      function () {
        return require("private-next-pages/clear-frontier/preview/s/[static].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clear-frontier/preview/s/[static]"])
      });
    }
  